import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatButtonModule,
  MatMenuModule,
  MatCheckboxModule,
} from '@angular/material';
import { XpoGMapBoardModule } from '@xpo-ltl/ngx-ltl-board-gmaps';
import { XpoAgGridBoardModule } from '@xpo-ltl/ngx-ltl-board-grid';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core';
import { XpoButtonModule, XpoCardModule } from '@xpo-ltl/ngx-ltl-core';
import { AgGridModule } from 'ag-grid-angular';
import { InboundPlanningSharedModule } from '../../shared';
import { pndFrameworkComponentsDeclarations } from '../../shared/components/frameworkComponents';
import { UnassignedPickupsComponent } from './unassigned-pickups.component';

@NgModule({
  declarations: [UnassignedPickupsComponent],
  exports: [UnassignedPickupsComponent],
  entryComponents: [UnassignedPickupsComponent],
  imports: [
    AgGridModule.withComponents(pndFrameworkComponentsDeclarations),
    CommonModule,
    XpoIconModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatMenuModule,
    XpoButtonModule,
    XpoAgGridBoardModule,
    XpoCardModule,
    XpoGMapBoardModule,
    InboundPlanningSharedModule,
  ],
})
export class UnassignedPickupsModule {}
